import { CLOUDFRONT_URI } from 'constants/routes';
import { DEFAULT_AVATAR_PATH } from 'constants/userAppSettings';

import avatarPlaceholder from 'img/icons/default-avatar.svg';

export const getCloudfrontURI = path => {
  return `${CLOUDFRONT_URI}/${path}`;
};

export const getAvatarThumbForUser = (avatars, defaultThumb = null) => {
  if (!avatars) {
    return avatarPlaceholder;
  }

  return (
    (avatars[0] && getCloudfrontURI(avatars[0].thumb)) ||
    defaultThumb ||
    avatarPlaceholder
  );
};

export const getAvatarLargeForUser = avatars => {
  if (avatars[0]?.large !== DEFAULT_AVATAR_PATH) {
    return getCloudfrontURI(avatars[0].large);
  }
};

export const getAvatarFromPath = path => {
  return (path && getCloudfrontURI(path)) || avatarPlaceholder;
};

export const getUserAvatarThumb = avatars => {
  if (avatars && avatars[0] && avatars[0].thumb !== DEFAULT_AVATAR_PATH) {
    return getCloudfrontURI(avatars[0].thumb);
  }
};
